var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_323)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_839_323)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_839_323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0H16C7.16344 0 0 7.16344 0 16V44C0 52.8366 7.16344 60 16 60H44C52.8366 60 60 52.8366 60 44V16C60 7.16344 52.8366 0 44 0Z",
    fill: "#FFCAFA"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M18 35.04V32.84L24.54 23.48H27.8V32.6H29.56V35.04H27.8V37.88H25V35.04H18ZM25.18 26.48L21.08 32.6H25.18V26.48Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0668 25.6119V28.8279C33.0668 29.0519 33.1188 29.2159 33.2228 29.3199C33.3348 29.4159 33.5188 29.4639 33.7748 29.4639H34.5548V30.8799H33.4988C32.0828 30.8799 31.3748 30.1919 31.3748 28.8159V25.6119H30.5828V24.2319H31.3748V22.5879H33.0668V24.2319H34.5548V25.6119H33.0668Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.867 24.136C40.371 24.136 40.819 24.248 41.211 24.472C41.603 24.688 41.907 25.012 42.123 25.444C42.347 25.868 42.459 26.38 42.459 26.98V30.88H40.779V27.208C40.779 26.68 40.647 26.276 40.383 25.996C40.119 25.708 39.759 25.564 39.303 25.564C38.839 25.564 38.471 25.708 38.199 25.996C37.935 26.276 37.803 26.68 37.803 27.208V30.88H36.123V22H37.803V25.06C38.019 24.772 38.307 24.548 38.667 24.388C39.027 24.22 39.427 24.136 39.867 24.136Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_839_323",
    x: -3,
    y: -3,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_839_323"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_839_323",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_839_323",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_839_323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourth);
export default __webpack_public_path__ + "static/media/fourth.869cdbb8bd06121570b91441e9a3e28b.svg";
export { ForwardRef as ReactComponent };